module.exports = __webpack_public_path__ + "static/media/chevron-left.eb4f11d9.svg";